
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const { State, Action } = namespace("Root");

@Component
export default class WizardCart extends Vue {
  @State("cart") cart: any;
}
